export default function truncateString(str, maxLength) {
  if (str?.length > maxLength) {
    return str.slice(0, maxLength) + "...";
  }
  return str;
}
